import { ReviewsCarouselContainer } from 'components/carousels/ReviewsCarouselContainer'
import Skeleton from 'react-loading-skeleton'
import { range } from 'utils/arrays'

export function ReviewsCarouselSkeleton() {
  return (
    <ReviewsCarouselContainer>
      {range(0, 6).map(i => (
        <Skeleton
          key={i}
          className='rounded-lg min-w-[16.8125rem] sm:min-w-[20.25rem] aspect-4/3'
        />
      ))}
    </ReviewsCarouselContainer>
  )
}
